export const FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_REQUEST = 'FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_REQUEST'
export const FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_SUCCESS = 'FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_SUCCESS'
export const FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_FALUIRE = 'FETCH_GET_SPECIAL_TASK_BY_TEMPLATE_ID_FALUIRE'
